import styled, { css } from 'styled-components';

import { media, getThemeColor, getThemeTransition } from '@utils/styled';

import Typography from '@common/components/Typography';

export const ContentWrapper = styled.div`
  grid-column: span 12;
  max-width: 100%;

  ${media.from640up`
    grid-column: 2 / 12
  `}

  ${media.from880up`
    grid-column: span 5;
  `}

  ${media.from1200up`
    grid-column: span 4;
  `}
`;

export const ContentContainer = styled.div`
  position: sticky;
  will-change: top;
  transition: ${({ shouldAnimate }) =>
    shouldAnimate && getThemeTransition('top', 'fast')};

  & > *:first-child {
    will-change: padding-top;
    transition: ${getThemeTransition('padding-top')};

    ${media.from880up`
    ${({ isStickyBarVisible, shouldAnimate, isScrollingDown, hasLabel }) =>
      isStickyBarVisible &&
      (shouldAnimate || !isScrollingDown) &&
      !hasLabel &&
      css`
        padding-top: 4rem;
      `}
    `}
  }

  & > *:not(button):last-child {
    will-change: padding-bottom;
    transition: ${getThemeTransition('padding-bottom')};

    ${media.from880up`
      ${({ isScrolled, shouldAnimate }) =>
        !isScrolled &&
        !shouldAnimate &&
        css`
          padding-bottom: 4rem;
        `}
    `}
  }
`;

export const ArticleNumber = styled(Typography).attrs({ variant: 'body2' })`
  color: ${getThemeColor('bluegrey.70')};
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 4)}
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 2)}
`;

export const SectionTitle = styled(Typography).attrs({ variant: 'body2' })`
  color: ${getThemeColor('bluegrey.60')};

  ${({ withSmallSpacing }) =>
    withSmallSpacing &&
    css`
      margin-top: 0;
    `}

  &:first-child {
    margin-top: 0;
  }
`;

export const Title = styled(Typography).attrs({
  customAs: 'h1',
  variant: 'h5',
})`
  ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'equal', 6)};
`;
